<section>
  <app-form-header [menuDefinition]="menuDefinition" (onSave)="onSubmit()" (onCancel)="cancel()"></app-form-header>

  @if (licenseLimitsMaxedOut && !licenseLimitsExceeded) {
    <app-information-block
      [status]="'warning'"
      [text]="'LICENSE_LIMIT.LIMIT_MAXED_OUT_WARNING' | translate"
      />
  }

  @if (licenseLimitsExceeded) {
    <app-information-block [status]="'error'" [text]="'LICENSE_LIMIT.LIMIT_BREACHED_WARNING' | translate" />
  }

  @if (form) {
    <form class="astral-content-width astral-stack-l" [formGroup]="form" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['rentalId']"></astral-input>
          @if (allowedFormsOfLease.length > 1) {
            <astral-select
              [control]="form.controls['formOfLease']"
              [itemsSource]="allowedFormsOfLease"
            ></astral-select>
          }
          <astral-select [control]="form.controls['company']" [itemsSource]="companies"></astral-select>
          <astral-select [control]="form.controls['property']" [itemsSource]="properties"></astral-select>
          <astral-select [control]="form.controls['rentalObjectType']" [itemsSource]="rentalObjectTypes"></astral-select>
          <astral-input [control]="form.controls['parkingNumber']"></astral-input>
          <astral-input type="number" [control]="form.controls['surface']"></astral-input>
          <astral-checkbox [control]="form.controls['parkingHasElectricity']"></astral-checkbox>
          <astral-checkbox [control]="form.controls['isGarage']"></astral-checkbox>
          <astral-checkbox [control]="form.controls['parkingHasRoof']"></astral-checkbox>
        </astral-layout-group>
        <astral-textarea [control]="form.controls['note']" [rows]="4"></astral-textarea>
        <app-address [group]="form.controls['address']" [model]="dataContext.address"></app-address>
      </section>
      @if (dataContext.isNew && showTemplateRows) {
        <section class="astral-section-surface astral-stack-l">
          <app-lease-rows
            [form]="form"
            [currency]="currencyCode"
            [companyId]="dataContext.companyId"
            [header]="true"
            [leaseStartDate]="leaseRowStart"
            [rentalObjectSize]="dataContext.surface"
            [currentDuePeriodFrom]="dataContext.currentDuePeriodFrom"
            [currentDuePeriodTo]="dataContext.currentDuePeriodTo"
            [currentPeriodText]="dataContext.currentPeriodText"
            [leaseAgreementInvoicePeriod]="1"
            [leaseAgreementCategory]="'Parking'"
            [cultureName]="cultureName"
            [itemsSource]="dataContext.leaseAgreementRowTemplates"
            [entityId]="dataContext.id"
            [contractService]="dataService"
            (itemSourceChange)="onItemSourceChange($event)"
            (leaseRowsChange)="onLeaseRowsChange($event)"
          ></app-lease-rows>
        </section>
      }
      @if (!dataContext.isNew && showTemplateRows) {
        <div class="astral-accordion-stack">
          @if (showBrf) {
            <section class="astral-section-surface astral-stack-l">
              <h4>{{ 'COOPERATIVE_HOUSING.COOPERATIVE_HOUSING_INFORMATION' | translate }}</h4>
              <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
                <astral-input
                  [control]="brfForm.controls['economicalPlanNumber']"
                  [helpText]="'COOPERATIVE_HOUSING.HELP_TEXT.ECONOMICAL_PLAN_NUMBER'"
                ></astral-input>
                <astral-input type="number" [control]="brfForm.controls['share']"></astral-input>
                <app-money-box
                  class="astral-layout-item"
                  [control]="brfForm.controls['contributionAmount']"
                  [helpText]="'COOPERATIVE_HOUSING.HELP_TEXT.CONTRIBUTION_AMOUNT'"
                ></app-money-box>
                <app-money-box class="astral-layout-item" [control]="brfForm.controls['baseAnnualFee']"></app-money-box>
                <app-money-box class="astral-layout-item" [control]="brfForm.controls['assignmentFee']"></app-money-box>
                <astral-date-picker [control]="brfForm.controls['assignmentDate']"></astral-date-picker>
                <astral-input type="number"
                  [control]="brfForm.controls['sharePercentage']"
                  [helpText]="'COOPERATIVE_HOUSING.HELP_TEXT.SHARE_PERCENTAGE'"
                ></astral-input>
                <astral-input type="number"
                  [control]="brfForm.controls['shareCompanySum']"
                  [helpText]="'COOPERATIVE_HOUSING.HELP_TEXT.SHARE_COMPANY_SUM'"
                ></astral-input>
              </astral-layout-group>
            </section>
          }
          <astral-accordion [header]="'LEASE_AGREEMENT_ROW.LIST_HEADER'" [helpText]="'LEASE_AGREEMENT_ROW.HELP_TEXT.RENTAL_OBJECT_RENT'">
            <div class="container-fluid">
              <div class="col-12">
                <app-lease-rows
                  [form]="form"
                  [currency]="currencyCode"
                  [companyId]="dataContext.companyId"
                  [leaseStartDate]="leaseRowStart"
                  [rentalObjectSize]="dataContext.surface"
                  [currentDuePeriodFrom]="dataContext.currentDuePeriodFrom"
                  [currentDuePeriodTo]="dataContext.currentDuePeriodTo"
                  [currentPeriodText]="dataContext.currentPeriodText"
                  [leaseAgreementInvoicePeriod]="1"
                  [leaseAgreementCategory]="'Parking'"
                  [cultureName]="cultureName"
                  [itemsSource]="dataContext.leaseAgreementRowTemplates"
                  [entityId]="dataContext.id"
                  [contractService]="dataService"
                  (itemSourceChange)="onItemSourceChange($event)"
                  (leaseRowsChange)="onLeaseRowsChange($event)"
                ></app-lease-rows>
              </div>
            </div>
          </astral-accordion>
          <astral-accordion
            [header]="'RENTAL_OBJECT_FORM.LEASE_AGREEMENT_TEMPLATE.TEMPLATE'"
            [helpText]="'RENTAL_OBJECT.HELP_TEXT.LEASE_AGREEMENT_TEMPLATE'"
            >
            <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
              <astral-select
                [control]="templateForm.controls['invoicePeriodMonths']"
                [itemsSource]="invoicePeriods"
                [helpText]="'LEASE_AGREEMENT.HELP_TEXT.INVOICE_PERIOD_LABEL'"
              ></astral-select>
              <astral-input type="number" [control]="templateForm.controls['noticePeriodTenant']"></astral-input>
              <astral-input type="number" [control]="templateForm.controls['noticePeriodLandlord']"></astral-input>
              <astral-select
                [control]="templateForm.controls['parkingElectricityPayment']"
                [itemsSource]="parkingElectricityPaymentOptions"
              ></astral-select>
              <astral-textarea [span]="'full'" [control]="templateForm.controls['specialTerms']"></astral-textarea>
            </astral-layout-group>
          </astral-accordion>
          @if (showBrf) {
            <astral-accordion [header]="'COOPERATIVE_HOUSING.MORTGAGE_PRESCRIPTION'">
              <div class="container-fluid">
                <div class="col-12">
                  <app-rental-object-mortgage-prescriptions
                    [forms]="form.controls['brfMortgagePrescriptions']"
                    [rentalObject]="dataContext"
                  ></app-rental-object-mortgage-prescriptions>
                </div>
              </div>
            </astral-accordion>
          }
          <astral-accordion [header]="'RENTAL_OBJECT_FORM.OBJECT_DESCRIPTION'">
            <astral-layout-group [columns]="1">
              <letting-translation-control [control]="form.controls['rentalObjectDescription']" type="area"></letting-translation-control>
            </astral-layout-group>
          </astral-accordion>
          <astral-accordion [header]="'RENTAL_OBJECT.LETTING_PROPERTIES'">
            <div class="container-fluid">
              <div class="col-12">
                <app-letting-features-form
                  [forms]="form.controls['lettingFeatures']"
                  [dataContext]="{ destinationIds: [dataContext.id] }"
                  [submitEvent]="submitEvent"
                ></app-letting-features-form>
              </div>
            </div>
          </astral-accordion>
          <astral-accordion [header]="'RENTALOBJECT_KEY.KEYS'">
            <div class="container-fluid">
              <div class="col-12">
                <app-rental-object-keys [forms]="form.controls['keys']" [rentalObject]="dataContext"></app-rental-object-keys>
              </div>
            </div>
          </astral-accordion>
          <astral-accordion [header]="'RENT_APPLICATION.APPLICATION_LIST'" [allowWidthExpansion]="true">
            <div class="container-fluid">
              <div class="col-12">
                <app-list-view
                  [columnDefinition]="rentApplicationsColumnDefinition"
                  [itemsSource]="dataContext.rentApplications"
                  [preferencesKey]="'parking.rent-applications'"
                  (rowClick)="onApplicationRowClicked($event)"
                ></app-list-view>
              </div>
            </div>
          </astral-accordion>
          <astral-accordion [header]="'CONSUMPTION.CONSUMPTION'" (stateChanged)="consumptionExpanded($event)">
            @if (consumptionIsExpanded) {
              <div class="container-fluid">
                <app-rental-object-meter
                  [form]="form.controls['imdMeterElectricity']"
                  [propertyMeters]="propertyMeters"
                  [propertyId]="propertyId"
                  [meterType]="mediaTypeElectricity"
                ></app-rental-object-meter>
              </div>
            }
          </astral-accordion>
          <astral-accordion [header]="'LEASE_AGREEMENT.LIST_HEADER'" [helpText]="'LEASE_AGREEMENT.HELP_TEXT.LEASE_AGREEMENT_LIST_RENTAL_OBJECT'" [allowWidthExpansion]="true">
            <div class="container-fluid">
              <div class="col-12">
                <app-list-view
                  [columnDefinition]="leaseAgreementColumnDefinition"
                  [itemsSource]="dataContext.leaseAgreements"
                  [preferencesKey]="'parking.lease-agreements'"
                  (rowClick)="onRowClicked($event)"
                ></app-list-view>
              </div>
            </div>
          </astral-accordion>
          <astral-accordion [header]="'VACANT_RENTAL_OBJECT_LIST.VACANT_PERIODS'" [allowWidthExpansion]="true">
            <div class="astral-stack-l">
              <section class="astral-content-width astral-stack-l">
                <h5 class="rental-blocks-title">{{ 'RENTAL_OBJECT.LETTING_BLOCK' | translate }}</h5>
                <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="COMMON.ADD" (click)="addRentalBlock()"></astral-button>
                <div class="astral-stack-m" formArrayName="rentalBlocks">
                  @for (rentalBlock of rentalBlockForms.controls; track rentalBlock; let i = $index) {
                    <section
                      class="astral-section-surface astral-section-surface--compact"
                      [formGroupName]="i"
                      >
                      <astral-layout-group [columns]="5" [tabletColumns]="2" [mobileColumns]="1">
                        <astral-date-picker [control]="rentalBlock.get('fromDate')"></astral-date-picker>
                        <astral-date-picker [control]="rentalBlock.get('toDate')"></astral-date-picker>
                        <astral-input [control]="rentalBlock.get('reason')"></astral-input>
                        <astral-input [control]="rentalBlock.get('project')"></astral-input>
                        <div class="astral-form-adjacent-action">
                          <astral-button variant="primary" size="small" type="button" icon="trash" labelKey="DELETE_BTN" (click)="removeRentalBlock(i)"></astral-button>
                        </div>
                      </astral-layout-group>
                    </section>
                  }
                </div>
              </section>
              <app-list-view
                [columnDefinition]="vacantPeriodsColumnDefinition"
                [itemsSource]="dataContext.vacancyPeriods"
                [preferencesKey]="'parking.vacant-periods'"
              ></app-list-view>
            </div>
          </astral-accordion>
          <astral-accordion [header]="'FAULT_NOTIFICATION.LIST_HEADER'" (stateChanged)="setFaultNotificationsVisibility($event)" [allowWidthExpansion]="true">
            <div class="container-fluid">
              <div class="col-12">
                <app-list-view
                  [columnDefinition]="faultNotificationsColumnDefinition"
                  [itemsSource]="dataContext.faultNotifications"
                  [preferencesKey]="'parking.fault-notifications'"
                  (rowClick)="onFaultNotificationRowClicked($event)"
                ></app-list-view>
              </div>
            </div>
          </astral-accordion>
          @if (showAdverts) {
            <astral-accordion
              [header]="'LETTING.ADVERTISMENT.PARKING_ADVERTISMENT'"
              (stateChanged)="allowSectionInit('advertisments')"
              [allowWidthExpansion]="true">
              @if (isSectionAllowed('advertisments')) {
                <div class="col-12">
                  <app-list-view
                    [columnDefinition]="advertismentsColumnDefinition"
                    [itemsSource]="advertisments"
                    [preferencesKey]="'parking.advertisements'"
                    (rowClick)="onAdvertismentRowClicked($event)"
                  ></app-list-view>
                </div>
              }
            </astral-accordion>
          }
          <astral-accordion [header]="'DOCUMENT.DOCUMENTS'" [counter]="rentalObjectDocumentCount" [fragment]="documentsFragment">
            <div class="astral-stack-l">
              <div class="astral-action-with-help">
                <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="LEASE_AGREEMENT.COMMAND.LINK_DOCUMENT" (click)="linkDocument()"></astral-button>
              </div>
              <app-rental-object-document-manager
                [rentalObjectId]="dataContext?.id"
                (countChange)="onRentalObjectDocumentsCountChanged($event)"
              ></app-rental-object-document-manager>
            </div>
          </astral-accordion>
          @if (form) {
            <astral-accordion [header]="'LOG.HEADER'" (stateChanged)="allowSectionInit('logs')" [allowWidthExpansion]="true">
              @if (isSectionAllowed('logs')) {
                <div class="container-fluid wrap-rows">
                  <app-list-view [columnDefinition]="logColumnDefinition" [itemsSource]="logs" [preferencesKey]="'parking.logs'"></app-list-view>
                </div>
              }
            </astral-accordion>
          }
        </div>
      }
    </form>
  }
</section>
